/**
 * GA4 (gtag) helpers — measurement ID from index.html.
 */
import { getVisitorSnapshot } from './visitorContext.js';

const GA_MEASUREMENT_ID = 'G-B26C3EMCCM';

let utm = {};

function readUtmFromLocation() {
  if (typeof window === 'undefined') return;
  const q = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  keys.forEach((k) => {
    const v = q.get(k);
    if (v) utm[k] = v;
  });
}

function gtagSafe() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

export function initAnalytics() {
  readUtmFromLocation();
  if (!gtagSafe()) return;
  const snap = getVisitorSnapshot();
  window.gtag('set', 'user_properties', {
    ui_language: snap.lang || 'en',
    visitor_country: snap.geo?.country || '',
  });
}

export function getUtmParams() {
  return { ...utm };
}

/** @param {string} name GA4 event name (snake_case) */
export function trackEvent(name, params = {}) {
  if (!gtagSafe()) return;
  const snap = getVisitorSnapshot();
  window.gtag('event', name, {
    ...getUtmParams(),
    ui_language: snap.lang || 'en',
    visitor_country: snap.geo?.country || '',
    origin_iata: snap.originIata || '',
    ...params,
  });
}

export { GA_MEASUREMENT_ID };
